var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-select"},_vm._l((_vm.items),function(item){return _c('li',{key:item.value,staticClass:"list-select__item",class:{
      'list-select__item--selected': item.value === _vm.value,
    },on:{"click":function($event){return _vm.$emit('input', item.value)}}},[(item.icon)?_c('i',{staticClass:"list-select__icon material-icons"},[_vm._v("\n      "+_vm._s(item.icon)+"\n    ")]):_vm._e(),_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }